;(function () {

	document.addEventSelectorListener("click", "[data-increment]", function (event, target) {
		event.preventDefault();

		let input = target.closest(".form-group").querySelector("input");
		let value = parseInt(input.value);
		if (!value) {
			value = 0;
		}

		let step = parseInt(target.getAttribute("data-increment"));
		value += step;

		if (input.getAttribute("min")) {
			let min = parseInt(input.getAttribute("min"));
			if (value < min) {
				value = min;
			}
		}

		input.value = value;
	});

}());